import React from 'react'
import { SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizQuestionBase } from '../QuizQuestion'

export const ColorPalettePage: React.FC = () => {
  return <QuizQuestionBase hardScreen={SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE} />
}
